import { render } from "./UserMenu.vue?vue&type=template&id=5bddc284&scoped=true"
import script from "./UserMenu.vue?vue&type=script&lang=js"
export * from "./UserMenu.vue?vue&type=script&lang=js"

import "./UserMenu.vue?vue&type=style&index=0&id=5bddc284&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bddc284"]])

export default __exports__